import { parse } from 'date-fns';

const stringToDate = (str: string | null): Date | null =>
  str ? parse(str.substring(0, 10), 'yyyy-MM-dd', new Date()) : null;

export default stringToDate;
